<div class="card-body">
    <div id="apex-basic-column-chart"></div>
</div>